import Api from "@/helpers/api.js";
import {createSkillPayload, processSkillRecords} from "@/store/payloadHelper.js";

export default {
	addSkill({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.post("/skills", item)
				.then((response) => {
					commit("ADD_SKILL", Object.assign(item, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDataListItems({commit, dispatch}) {
		return new Promise((resolve, reject) => {
			Api.get("/skills")
				.then((res) => {
					commit("SET_SKILLS", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateItem({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.put(`/skills/${item.id}`, item.payload)
				.then((response) => {
					commit("UPDATE_SKILL", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/skills/${itemId}`)
				.then((response) => {
					commit("REMOVE_SKILL", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	addSkillVisitPoint({commit}, skillItems) {
		commit("ADD_SKILL_VISIT_POINT", skillItems);
	},
	findVisitPointSkillById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/visitpointskill/${id}`)
				.then((res) => {
					commit("ADD_SKILL_VISIT_POINT", skillItems);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findSkillFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				fields: [
					"id",
					"name",
					"description",
					"vehicle_id",
					"visit_point_id",
					"company_id",
					"added_on",
					"update_on",
				],
				id: data.id || [],
				name: data.name || [],
				description: data.description || [],
				vehicle_id: data.vehicle_id || [],
				visit_point_id: data.visit_point_id || [],
				order_by: data.order_by || ["name"],
				sort: data.sort || "asc",
			};
			Api.post("/skills/filter", payload)
				.then((res) => {
					commit("ADD_SKILL_VISIT_POINT", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findSkillPaginateFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createSkillPayload(data);
			Api.post("/skills/filter", payload)
				.then((res) => {
					const processedRecords = processSkillRecords(res.data.records);
					commit("SET_SKILLS", processedRecords);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
